import React, { useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig"; 

function OrderTracking() {
  const [orderId, setOrderId] = useState("");
  const [orderData, setOrderData] = useState(null);

  const handleTrack = async () => {
    const docRef = doc(db, "orders", orderId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setOrderData(docSnap.data());
    } else {
      alert("Order not found!");
    }
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Enter Order ID"
        onChange={(e) => setOrderId(e.target.value)}
      />
      <button onClick={handleTrack}>Track Order</button>

      {orderData && (
        <div>
          <p>Status: {orderData.status}</p>
          <p>Items: {orderData.items.join(", ")}</p>
        </div>
      )}
    </div>
  );
}

export default OrderTracking;
